(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/chat/chat-data/assets/javascripts/reducers/chat-meta-reducer.js') >= 0) return;  svs.modules.push('/components/chat/chat-data/assets/javascripts/reducers/chat-meta-reducer.js');

'use strict';

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
const _svs$components$chat$ = svs.components.chat.chatData,
  _svs$components$chat$2 = _svs$components$chat$.actions,
  CHAT_DELETE_MESSAGE_FAILURE = _svs$components$chat$2.CHAT_DELETE_MESSAGE_FAILURE,
  CHAT_DELETE_MESSAGE_SUCCESS = _svs$components$chat$2.CHAT_DELETE_MESSAGE_SUCCESS,
  CHAT_DELETE_MESSAGE_INIT = _svs$components$chat$2.CHAT_DELETE_MESSAGE_INIT,
  CHAT_RECEIVE_MESSAGE = _svs$components$chat$2.CHAT_RECEIVE_MESSAGE,
  CHAT_PURGE_ROOM = _svs$components$chat$2.CHAT_PURGE_ROOM,
  _svs$components$chat$3 = _svs$components$chat$.constants,
  MESSAGE_STATUS_DELETE_PENDING = _svs$components$chat$3.MESSAGE_STATUS_DELETE_PENDING,
  MESSAGE_STATUS_DELETED = _svs$components$chat$3.MESSAGE_STATUS_DELETED,
  MESSAGE_STATUS_DELETE_FAILED = _svs$components$chat$3.MESSAGE_STATUS_DELETE_FAILED,
  SERVER_MESSAGE_STATUS_DELETED = _svs$components$chat$3.SERVER_MESSAGE_STATUS_DELETED;
const chatMetaReducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let action = arguments.length > 1 ? arguments[1] : undefined;
  const messageId = action.messageId,
    roomId = action.roomId,
    type = action.type;
  switch (type) {
    case CHAT_DELETE_MESSAGE_INIT:
      return _objectSpread(_objectSpread({}, state), {}, {
        [roomId]: _objectSpread(_objectSpread({}, state[roomId]), {}, {
          [messageId]: _objectSpread(_objectSpread({}, (state[roomId] || {})[messageId]), {}, {
            status: MESSAGE_STATUS_DELETE_PENDING
          })
        })
      });
    case CHAT_DELETE_MESSAGE_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        [roomId]: _objectSpread(_objectSpread({}, state[roomId]), {}, {
          [messageId]: _objectSpread(_objectSpread({}, (state[roomId] || {})[messageId]), {}, {
            status: MESSAGE_STATUS_DELETED
          })
        })
      });
    case CHAT_DELETE_MESSAGE_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        [roomId]: _objectSpread(_objectSpread({}, state[roomId]), {}, {
          [messageId]: _objectSpread(_objectSpread({}, (state[roomId] || {})[messageId]), {}, {
            status: MESSAGE_STATUS_DELETE_FAILED,
            error: action.error
          })
        })
      });
    case CHAT_RECEIVE_MESSAGE:
      {
        if (action.messageData.serverStatus === SERVER_MESSAGE_STATUS_DELETED &&
        (state[roomId] || {})["".concat(action.messageData.id)]) {
          const _state$roomId = state[roomId],
            _ref = "".concat(action.messageData.id),
            deleteMe = _state$roomId[_ref],
            remainingRoomMeta = _objectWithoutProperties(_state$roomId, [_ref].map(_toPropertyKey));
          return _objectSpread(_objectSpread({}, state), {}, {
            [roomId]: remainingRoomMeta
          });
        }
        return state;
      }
    case CHAT_PURGE_ROOM:
      {
        const _ref2 = "".concat(action.roomId),
          deleteMe = state[_ref2],
          saveUs = _objectWithoutProperties(state, [_ref2].map(_toPropertyKey));
        return saveUs;
      }
    default:
      return state;
  }
};
setGlobal('svs.components.chat.chatData.reducers.chatMetaReducer', chatMetaReducer);

 })(window);